/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Close_AriaInputs */

const en_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close inspector`)
};

const ar_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إغلاق الفاحص`)
};

const bn_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইন্সপেক্টর বন্ধ করুন`)
};

const de_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inspektor schließen`)
};

const es_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el inspector`)
};

const fr_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer l'inspecteur`)
};

const pt_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar o inspetor`)
};

const zh_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭检查器`)
};

const tr_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denetçiyi kapat`)
};

const ru_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть инспектор`)
};

const pl_image_inspector_close_aria = /** @type {(inputs: Image_Inspector_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij inspektor`)
};

/**
* | output |
* | --- |
* | "Close inspector" |
*
* @param {Image_Inspector_Close_AriaInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_close_aria = /** @type {((inputs?: Image_Inspector_Close_AriaInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Close_AriaInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_close_aria(inputs)
	if (locale === "bn") return bn_image_inspector_close_aria(inputs)
	if (locale === "de") return de_image_inspector_close_aria(inputs)
	if (locale === "es") return es_image_inspector_close_aria(inputs)
	if (locale === "fr") return fr_image_inspector_close_aria(inputs)
	if (locale === "pt") return pt_image_inspector_close_aria(inputs)
	if (locale === "zh") return zh_image_inspector_close_aria(inputs)
	if (locale === "tr") return tr_image_inspector_close_aria(inputs)
	if (locale === "ru") return ru_image_inspector_close_aria(inputs)
	if (locale === "pl") return pl_image_inspector_close_aria(inputs)
	return en_image_inspector_close_aria(inputs)
});